<div class="container">
  <div class="page-header">
    <h2>Contacts</h2>
  </div>
  <p>Total: {{ totalCount() }}</p>
  <button (click)="handlePrev()">Previous</button>
  <button (click)="handleNext()">Next</button>
  <table class="table">
    <thead>
      <tr>
        <td></td>
        <th>Contact</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Type</th>
      </tr>
    </thead>
    <tbody>
      @for (contact of contacts(); track contact.id) {
        <tr>
          <td>{{ offset() + $index + 1 }}</td>
          <td>
            <a [routerLink]="[contact.id]">{{ contact.display }}</a>
          </td>
          <td>{{ contact.email }}</td>
          <td>{{ contact.phone }}</td>
          <td>{{ contact.contact_type }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
